// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-forms-buttons-module__btn--WF51q {
  display: inline-block;
  background: #81a2ca;
  color: #ffffff;
  border: 0;
  border-radius: 4px;
  outline: 0;
  padding: 5px 30px;
  font-weight: 400;
}

.src-js-components-forms-buttons-module__btn--WF51q:focus,
.src-js-components-forms-buttons-module__btn--WF51q:hover {
  background: #4a709d;
  cursor: pointer;
}

.src-js-components-forms-buttons-module__btn--WF51q:disabled {
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.65;
}

.src-js-components-forms-buttons-module__btnPrimary--s201d {
  background: #ff9600;
}

.src-js-components-forms-buttons-module__btnPrimary--s201d:focus,
.src-js-components-forms-buttons-module__btnPrimary--s201d:hover {
  background: #fadaa0;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/forms/buttons.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":[".btn {\n  display: inline-block;\n  background: #81a2ca;\n  color: #ffffff;\n  border: 0;\n  border-radius: 4px;\n  outline: 0;\n  padding: 5px 30px;\n  font-weight: 400;\n}\n\n.btn:focus,\n.btn:hover {\n  background: #4a709d;\n  cursor: pointer;\n}\n\n.btn:disabled {\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.65;\n}\n\n.btnPrimary {\n  background: #ff9600;\n}\n\n.btnPrimary:focus,\n.btnPrimary:hover {\n  background: #fadaa0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `src-js-components-forms-buttons-module__btn--WF51q`,
	"btnPrimary": `src-js-components-forms-buttons-module__btnPrimary--s201d`
};
export default ___CSS_LOADER_EXPORT___;
